import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from "@angular/core";
import { ExpenseClassification } from "src/app/receipt-long-op/generated/domain-models/enums/generated-expense-classification";
import { SvgIconComponent } from '@ngneat/svg-icon';
import { NTSTranslatePipe, TextButtonComponent } from "@nts/std";
import { CurrencyPipe, DatePipe, NgIf } from "@angular/common";
import { CurrencyUtils } from "../../utils/currency-utils";
import { Currency } from "src/app/external-remote/currency/currency";

@Component({
    selector: 'nts-single-expense',
    templateUrl: './single-expense.component.html',
    styleUrls: ['./single-expense.component.scss'],
    standalone: true,
    imports: [
        SvgIconComponent,
        TextButtonComponent,
        NTSTranslatePipe,
        CurrencyPipe,
        DatePipe,
        NgIf
    ]
})
export class SingleExpenseComponent implements OnInit {

    @Input() icon!: string;
    @Input() type!: ExpenseClassification;
    @Input() totalAmount!: number;
    @Input() date!: Date;
    @Input() notes!: string;
    @Input()
    @HostBinding('class.selection-mode')
    selectionMode!: boolean;
    @Input() currencyIso?: string;
    @Input() currency?: Object;


    @Input() newLabels = [];

    @Input()
    @HostBinding('style.background')
    color!: string;

    @Output() onEdit = new EventEmitter<void>();
    @Output() onDelete = new EventEmitter<void>();
    @Output() onSelectionChanged = new EventEmitter<boolean>();

    @HostBinding('class.is-selected')
    isSelected = false;

    expenseTypeEnum = ExpenseClassification;

    constructor() { }

    toggleSelection() {
        this.isSelected = !this.isSelected;
        this.onSelectionChanged.emit(this.isSelected);
    }

    ngOnInit(): void {
    }

    @HostBinding('class.is-disabled')
    disableSelectionButton(): boolean {
        return this.selectionMode && this.currencyIso != this.currency['isoCode'];
    }

    getCurrencySymbol(): string {
        if (this.currency) {
            return CurrencyUtils.getCurrencySymbol(this.currency as Currency);
        }

        if (this.currencyIso?.length > 0) {
            return CurrencyUtils.getCurrencySymbol({ isoCode: this.currencyIso } as Currency);
        }

        return '';
    }

    decimalFormatterFromNumber(numberValue: number) {
        const zero: number = 0;
        return numberValue ? numberValue.toLocaleString('it', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : zero.toLocaleString('it', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}
